module.exports = __webpack_public_path__ + "static/img/cascader.af4b06f5.svg";